import { useEffect, useRef } from 'react';
import checkedIcon from '@/evercall/ui/assets/checkedIcon.svg';
import config from '@evercall/config';

import styles from './formSuccess.module.scss';

const FormSuccess = () => {
  const successRef = useRef(null);
  const { supportEmail, supportPhoneNumber } = config;

  useEffect(() => {
    window.scrollTo(0, successRef.current.offsetTop);
  }, []);

  return (
    <div className={ styles.successContainer } data-test="successContainer">
      <img src={ checkedIcon.src } alt="Success submit" />
      <h1 className={ styles.title }>Thank you for submitting your request!</h1>
      <div
        className={ styles.successText }
        ref={ successRef }
      >
        <p>
          Our fanatical 24x7 support team will promptly review your event details and revert with confirmation on
          availability.
        </p>
        <p>
          If you have additional questions or comments, please reach out
          to <a href={ `mailto:${ supportEmail }` }>{ supportEmail }</a> or call <strong>{ supportPhoneNumber }</strong>.
        </p>
      </div>
    </div>
  );
};

export default FormSuccess;
